// Generated by ts-to-zod
import { z } from 'zod';
import { emailLimitsSchema } from './emailLimits.schema';

export const organizationLimitsSchema = z.object({
  emailLimits: emailLimitsSchema,
});
